import React, { Dispatch, SetStateAction } from 'react'
import styles from './ArtistInfo.module.scss'
import { FilterButton } from 'components/SA/Filters'
import FiltersChips from '../FiltersChips/FiltersChips'
import Skeleton from 'components/SA/Skeleton'
import useAvoidLayoutShift from 'hooks/useAvoidLayoutShift'

type ArtistInfoProps = {
  isFiltersVisible: boolean
  setIsFiltersVisible: Dispatch<SetStateAction<boolean>>
  onOpenMobileFilter: () => void
  customClearFilterCallback?: () => void
  baseUrl: string
}

const ArtistInfo = (props: ArtistInfoProps) => {
  const { isFiltersVisible, onOpenMobileFilter, baseUrl, customClearFilterCallback } = props
  const { isSkeletonVisible } = useAvoidLayoutShift()

  return (
    <div className={styles.artistInfoHeaderWrapper}>
      <div className={styles.filtersSelectedContainer}>
        {isSkeletonVisible ? (
          <Skeleton width='160px' height='40px' />
        ) : (
          <div className={styles.mobileFilterButton}>
            <FilterButton
              onClickFilterButton={onOpenMobileFilter}
              isFiltersVisible={isFiltersVisible}
            />
            <FiltersChips baseUrl={baseUrl} customClearFilterCallback={customClearFilterCallback} />
          </div>
        )}
      </div>
    </div>
  )
}

export default ArtistInfo
